import React from "react";
import ActionButton from "../Buttons/ActionButton";
import OutlinedButton from "../Buttons/OutlinedButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import { ReactComponent as PhotoIcon } from "../../assets/icons/photo.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";

type Props = {
  images: any;
  imageIndex?: any;
  onImageChange: any;
  activeAnnotationId: any;
  annotations: any;
  onActiveAnnotationIdChange: any;
  onAnnotationDelete: any;
};

const AnnotationImageList = ({
  images,
  imageIndex,
  onImageChange,
  annotations,
  activeAnnotationId,
  onActiveAnnotationIdChange,
  onAnnotationDelete,
}: Props) => {

  return (
    <div className="annotation-sidebar-secondary">
      <div className="sidebar-title">Images</div>
      <div className="annotation-button-section">
        { imageIndex > 0 && <OutlinedButton onClick={() => onImageChange(imageIndex - 1)}>Back</OutlinedButton>}
        { imageIndex < images.length - 1 && <PrimaryButton onSubmit={() => onImageChange(imageIndex + 1)}>Next</PrimaryButton>}
      </div>
      <div className="annotation-sidebar-content">
        {images &&
          images?.map((image, index) => (
            <ActionButton
              icon={<PhotoIcon />}
              label={image.fileName}
              className={`annotation-sidebar-item ${image.url == images[imageIndex]?.url && "active-sidebar-item"}`}
              onClick={() => onImageChange(index)}
              key={index}
            />
          ))}
      </div>
      <div className="sidebar-title">Annotations</div>
      <div className="annotation-sidebar-content">
        {annotations &&
          annotations?.map((annotation, index) => (
            <div style={{display: "flex", width: "100%", justifyContent: "space-between"}} key={index}>
              <ActionButton
                icon={<PhotoIcon />}
                label={`Ann ${annotation.id} - ${annotation.type}`}
                className={`annotation-sidebar-item ${annotation.id == activeAnnotationId && "active-sidebar-item"}`}
                onClick={() => onActiveAnnotationIdChange(annotation.id)}
              />
              <ActionButton
                icon={<DeleteIcon className="delete-icon" />}
                className={`annotation-sidebar-item delete`}
                onClick={() => onAnnotationDelete(annotation.id)}
              />
          </div>
          ))}
      </div>
    </div>
  );
};

export default AnnotationImageList;
